export var AdvertsManagerState = /*#__PURE__*/ function(AdvertsManagerState) {
    // Initial State
    AdvertsManagerState["Uninitialised"] = "Uninitialised";
    // Ads initialised with success
    AdvertsManagerState["Initialised"] = "Initialised";
    // Ads disabled via config, killswitch, etc.
    AdvertsManagerState["Disabled"] = "Disabled";
    return AdvertsManagerState;
}({});

//# sourceMappingURL=adverts-manager-stage.enums.js.map